const TOURPLAN_CUSTOM_RATES_COMMON_SETTINGS = [
  'customRatesEnableForQuotesAndBookings',
  'customRateServiceStatus',
  'customRatesCalculateWithLastYearsRate',
  'customRatesExtendedBookingYears',
  'customRatesEligibleRateTypes',
  'customRatesRoundRates',
  'customRatesRoundToTheNearestDollar',
  'sendServicesWithoutARate',
];

const TOURPLAN_CUSTOM_RATES_PARTNER_SETTINGS = [
  'customRatesMarkupPercentage',
];

const TOURPLAN_RATES_API_SETTINGS = ['endpoint', 'username', 'password'];

const TOURPLAN_HOST_CONNECT_SETTINGS = [
  'hostConnectEndpoint',
  'hostConnectAgentID',
  'hostConnectAgentPassword',
  'hostConnectBookingLinkBaseUrl',
];

const TOURPLAN_PRODUCT_CONNECT_SETTINGS = [
  'productConnectEndpoint',
  'productConnectUser',
  'productConnectUserPassword',
];

const TOURPLANNX_TOKEN_ATTRIBUTES = [
  'url',
  'agentCode',
  'bookingStatus',
  'serviceStatus',
  'branch',
  'department',
  'productQueryConcurrency',
];

const TOURPLANNX_OPTIONAL_TOKEN_ATTRIBUTES = [
  'agentCode',
  'currency',
  'serviceStatus',
  'branch',
  'department',
  'analysisCode1',
  'analysisCode2',
  'analysisCode3',
  'analysisCode4',
  'analysisCode5',
  'analysisCode6',
  'productSearchOmitServiceCodes',
];

export const integrationMetadata = {
  tourconnect: {
    name: 'TC AI',
    showHintField: true,
    hintMapToPartner: true,
    companyAttributes: [],
    directBookingAttributes: [],
    partnerHintAttributes: [],
    optionalAttributesForNonPartnerHint: [],
    optionalAttributesForPartnerHint: [],
  },
  fareharbor: {
    name: 'FareHarbor',
    showHintField: true,
    hintMapToPartner: true,
    allowDirectBooking: true,
    hiddenAttributes: ['appKey', 'endpoint'],
    companyAttributes: ['endpoint', 'shortName'],
    optionalAttributesForNonPartnerHint: ['affiliateShortName'],
    directBookingAttributes: ['endpoint', 'affiliateKey', 'shortName'],
    partnerHintAttributes: ['affiliateKey', 'affiliateShortName'],
    obfuscatedAttributes: ['affiliateKey'],
    optionalAttributesForPartnerHint: [],
  },
  ventrata: {
    name: 'Ventrata',
    showHintField: true,
    hintMapToPartner: true,
    allowDirectBooking: true,
    hiddenAttributes: ['endpoint', 'octoEnv', 'acceptLanguage'],
    companyAttributes: ['endpoint'],
    directBookingAttributes: ['apiKey'],
    partnerHintAttributes: ['apiKey', 'resellerId'],
    optionalAttributesForNonPartnerHint: [],
    optionalAttributesForPartnerHint: ['resellerId'],
  },
  tourplan: {
    name: 'Tourplan',
    showHintField: true,
    hintMapToPartner: true,
    directBookingAttributes: [
      ...TOURPLAN_HOST_CONNECT_SETTINGS,
      'ttlForProducts',
      'doNotCallPluginForProducts',
      'productSearchOmitServiceCodes',
      'productSearchPickupPointsRequired',
    ],
    partnerHintAttributes: [
      ...TOURPLAN_HOST_CONNECT_SETTINGS,
      ...TOURPLAN_CUSTOM_RATES_PARTNER_SETTINGS,
      'ttlForProducts',
      'doNotCallPluginForProducts',
      'productSearchOmitServiceCodes',
      'productSearchPickupPointsRequired',
    ],
    optionalAttributesForNonPartnerHint: [
      ...TOURPLAN_RATES_API_SETTINGS,
      ...TOURPLAN_HOST_CONNECT_SETTINGS,
      ...TOURPLAN_PRODUCT_CONNECT_SETTINGS,
      'ttlForProducts',
      'doNotCallPluginForProducts',
      'productSearchOmitServiceCodes',
      'productSearchPickupPointsRequired',
      'displayRateInSupplierCurrency',
      ...TOURPLAN_CUSTOM_RATES_COMMON_SETTINGS,
      ...TOURPLAN_CUSTOM_RATES_PARTNER_SETTINGS,
    ],
    optionalAttributesForPartnerHint: [
      ...TOURPLAN_RATES_API_SETTINGS,
      ...TOURPLAN_HOST_CONNECT_SETTINGS,
      ...TOURPLAN_PRODUCT_CONNECT_SETTINGS,
      'ttlForProducts',
      'doNotCallPluginForProducts',
      'productSearchOmitServiceCodes',
      'productSearchPickupPointsRequired',
      'displayRateInSupplierCurrency',
      ...TOURPLAN_CUSTOM_RATES_COMMON_SETTINGS,
      ...TOURPLAN_CUSTOM_RATES_PARTNER_SETTINGS,
    ],
    hiddenAttributes: [
      ...TOURPLAN_RATES_API_SETTINGS,
      ...TOURPLAN_PRODUCT_CONNECT_SETTINGS,
      'displayRateInSupplierCurrency',
      ...TOURPLAN_CUSTOM_RATES_COMMON_SETTINGS,
    ],
    companyAttributes: [
      ...TOURPLAN_RATES_API_SETTINGS,
      ...TOURPLAN_PRODUCT_CONNECT_SETTINGS,
      'displayRateInSupplierCurrency',
      ...TOURPLAN_CUSTOM_RATES_COMMON_SETTINGS,
    ],
  },
  zaui: {
    name: 'Zaui',
    showHintField: true,
    hintMapToPartner: true,
    allowDirectBooking: true,
    hiddenAttributes: ['apiKey'],
    companyAttributes: ['supplierId', 'supplierShortName'],
    directBookingAttributes: ['supplierId', 'supplierShortName'],
    partnerHintAttributes: ['resellerId'],
    optionalAttributesForNonPartnerHint: ['resellerId', 'supplierShortName'],
    optionalAttributesForPartnerHint: ['supplierShortName'],
  },
  bonza: {
    name: 'Bonza',
    showHintField: true,
    hintMapToPartner: true,
    allowDirectBooking: true,
    hiddenAttributes: [],
    companyAttributes: ['apiKey'],
    directBookingAttributes: ['endpoint', 'apiKey', 'bookingPartnerId'],
    partnerHintAttributes: ['endpoint', 'apiKey', 'bookingPartnerId'],
    optionalAttributesForNonPartnerHint: [],
    optionalAttributesForPartnerHint: [],
  },
  rezdy: {
    name: 'Rezdy',
    showHintField: true,
    hintMapToPartner: true,
    allowDirectBooking: true,
    hiddenAttributes: ['endpoint'],
    companyAttributes: ['endpoint'],
    directBookingAttributes: ['apiKey'],
    partnerHintAttributes: ['apiKey', 'agentCode'],
    optionalAttributesForNonPartnerHint: [],
    optionalAttributesForPartnerHint: [],
  },
  peek: {
    name: 'Peek Pro',
    showHintField: true,
    hintMapToPartner: true,
    allowDirectBooking: true,
    hiddenAttributes: [],
    companyAttributes: [],
    directBookingAttributes: ['apiKey'],
    partnerHintAttributes: ['apiKey'],
    optionalAttributesForNonPartnerHint: [],
    optionalAttributesForPartnerHint: [],
  },
  xola: {
    name: 'Xola',
    showHintField: true,
    hintMapToPartner: true,
    allowDirectBooking: true,
    autoCreateAffiliates: true,
    hiddenAttributes: [],
    companyAttributes: ['sellerId'],
    directBookingAttributes: ['sellerId'],
    partnerHintAttributes: ['affiliateCode', 'affiliateId'],
    optionalAttributesForNonPartnerHint: [],
    optionalAttributesForPartnerHint: [],
  },
  rms: {
    name: 'RMS',
    showHintField: true,
    hintMapToPartner: true,
    allowDirectBooking: true,
    hiddenAttributes: [],
    companyAttributes: ['clientId', 'clientPassword'],
    directBookingAttributes: ['clientId', 'clientPassword'],
    partnerHintAttributes: ['agentId'],
    optionalAttributesForNonPartnerHint: [],
    optionalAttributesForPartnerHint: [],
  },
  bokun: {
    name: 'Bokun',
    showHintField: true,
    hintMapToPartner: true,
    allowDirectBooking: true,
    hiddenAttributes: [],
    companyAttributes: ['endpoint'],
    directBookingAttributes: ['accessKey', 'secretKey', 'tenant'],
    partnerHintAttributes: ['accessKey', 'secretKey', 'tenant'],
    optionalAttributesForNonPartnerHint: [],
    optionalAttributesForPartnerHint: [],
  },
  tourplannx: {
    name: 'TourplanNX',
    showHintField: true,
    allowDirectBooking: true,
    hiddenAttributes: [],
    companyAttributes: [],
    directBookingAttributes: TOURPLANNX_TOKEN_ATTRIBUTES,
    partnerHintAttributes: TOURPLANNX_TOKEN_ATTRIBUTES,
    optionalAttributesForNonPartnerHint: TOURPLANNX_OPTIONAL_TOKEN_ATTRIBUTES,
    optionalAttributesForPartnerHint: TOURPLANNX_OPTIONAL_TOKEN_ATTRIBUTES,
  },
};

export const availableIntegrationIds = Object.keys(integrationMetadata).filter(
  integrationId => integrationMetadata[integrationId].name
);

export const isCredentialField = fieldName =>
  /(password|secret|api.?key|access.?key|affiliate.?key|token)/i.test(fieldName);

export const visibleCompanyAttributes = (integrationId, isAnAdmin) => {
  const metadata = integrationMetadata[integrationId] || {};
  const hidden = metadata.hiddenAttributes || [];
  return (metadata.companyAttributes || []).filter(
    attribute => isAnAdmin || !hidden.includes(attribute)
  );
};
